import * as React from "react"
import { Box, Typography } from "@mui/material"
import TabbedView from "../components/TabbedView"
import CameraTab from "../components/home/CameraTab"
import KeypointTab from "../components/home/KeypointTab"
import UploadTab from "../components/home/UploadTab"

export default function Home() {
  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h3">Identify a Climb</Typography>
        <Typography variant="subtitle1">
          Snap a photo or upload an image to detect the route
        </Typography>
      </Box>
      <TabbedView
        tabNames={["Camera", "Upload", "Keypoint"]}
        tabs={[<CameraTab />, <UploadTab />, <KeypointTab />]}
      />
    </Box>
  )
}
